import { Component, OnInit } from '@angular/core';
import {UserService } from "../../shared/services/user.service";
import { User } from "../../shared/models/user";
import { Role } from 'app/shared/models/role';

@Component({
  selector: 'app-user-list',
  templateUrl: './user-list.component.html',
  styleUrls: ['./user-list.component.css']
})
export class UserListComponent implements OnInit {

  private _users:User[];
  private singleAdmin:boolean;
  public showArchivedUsers:boolean;

  constructor(private userService:UserService) { 
    this._users = [];
    this.showArchivedUsers = false;
  }

  ngOnInit() {

    this.userService.getUsers().then((users) => {
      let adminUserId = 0;

      users.forEach(u => {
        if (u.role == Role.Admin) {
          if (adminUserId === 0) {
            adminUserId = u.id;
            this.singleAdmin = true;
          }
          else {
            this.singleAdmin = false;
          }
        }
      });
      this._users = users
    });
  }

  public restoreUser(user:User) {
    this.userService.restoreUser(user);
  }

  public archiveUser(user:User) {
    if (confirm("Are you sure you want to archive this user?")) {
      this.userService.archiveUser(user);
    }
  }

  public get Users() {
    return this._users.filter(u => {
      if (this.showArchivedUsers) {
        return !u.enabled;
      } else {
        return u.enabled;
      }
    });
  }

  toggleArchivedUsers() {
    this.showArchivedUsers = !this.showArchivedUsers;
  }

  doSearch(search:string) {

  }

  resetSearch() {

  }

  canDeleteUser(user:User) {
    if (this.singleAdmin && user.role == Role.Admin) {
      return false;
    }
    else if (user.role == Role.SuperUser) {
      return false;
    } else if (user.role == Role.Owner) {
      return false;
    }
    return true;
  }
}



// WEBPACK FOOTER //
// ./src/app/users/user-list/user-list.component.ts